function EventsIcon() {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13.1722V6.21568C1 5.75443 1.18322 5.31209 1.50937 4.98593C1.83552 4.6598 2.27786 4.47656 2.73912 4.47656H39.261C39.7222 4.47656 40.1646 4.6598 40.4906 4.98593C40.8167 5.31209 41 5.75443 41 6.21568V13.1722H1Z"
        fill="#FF808C"
      />
      <path
        d="M1 8.82438V6.21568C1 5.75443 1.18322 5.31209 1.50937 4.98593C1.83552 4.6598 2.27786 4.47656 2.73912 4.47656H39.261C39.7222 4.47656 40.1646 4.6598 40.4906 4.98593C40.8167 5.31209 41 5.75443 41 6.21568V8.82438H1Z"
        fill="#FFBFC5"
      />
      <path
        d="M1 13.1724H41V39.2594C41 39.7206 40.8167 40.163 40.4906 40.4891C40.1646 40.8151 39.7222 40.9986 39.261 40.9986H2.73912C2.27786 40.9986 1.83552 40.8151 1.50937 40.4891C1.18322 40.163 1 39.7206 1 39.2594V13.1724Z"
        fill="white"
      />
      <path
        d="M39.261 4.47803H2.73912C1.77863 4.47803 1 5.25665 1 6.21717V39.2606C1 40.2212 1.77863 40.9998 2.73912 40.9998H39.261C40.2214 40.9998 41 40.2212 41 39.2606V6.21717C41 5.25665 40.2214 4.47803 39.261 4.47803Z"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.69507 1V9.69566"
        stroke="#191919"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M32.3044 1V9.69566"
        stroke="#191919"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 13.1743H41"
        stroke="#191919"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.4348 33.1738H20.1304"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7826 33.1724V20.1289C15.7827 19.9651 15.7366 19.8046 15.6495 19.6659C15.5624 19.5272 15.4379 19.4161 15.2903 19.3449C15.1428 19.274 14.9782 19.2459 14.8154 19.2643C14.6527 19.2827 14.4985 19.3466 14.3705 19.4489L11.4348 21.7984"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.0866 33.1724L32.1841 20.555C32.2647 20.4241 32.3068 20.2729 32.3053 20.119C32.3036 19.9652 32.2587 19.8149 32.1754 19.6855C32.0875 19.5525 31.9676 19.4436 31.8265 19.3692C31.6855 19.2947 31.5278 19.2569 31.3685 19.2594H24.4779C24.2474 19.2594 24.0262 19.351 23.863 19.5142C23.7 19.6772 23.6084 19.8984 23.6084 20.1289V21.8681"
        stroke="#191919"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default EventsIcon;
